import styled from "styled-components";
import { ReactComponent as ManifestLogo } from "manifest-components/src/Images/icons/manifest-gray.svg";
import { RoutePaths, useTypedNavigate } from "../../routes/RoutePaths";

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
`;

export default function HeaderDefault() {
  const navigate = useTypedNavigate();

  const navigateToHome = () => {
    navigate(RoutePaths.welcome);
  };

  return (
    <StyledHeader>
      <button onClick={navigateToHome}>
        <ManifestLogo className="manifestLogo" />
      </button>
    </StyledHeader>
  );
}
